import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

/**
 * Esqueleto genérico de página: cabecera + rejilla de tarjetas.
 *
 * Es el fallback del Suspense del shell mientras llega el chunk de una ruta.
 * Ocupa el lugar del contenido sin tocar barra lateral ni cabecera, así que el
 * shell no parpadea y la espera se lee como "llegando", no como pantalla vacía.
 */
export function PageSkeleton({ className }: { className?: string }) {
  return (
    <div
      role="status"
      aria-label="Cargando página"
      className={cn("w-full animate-fade-in space-y-6", className)}
    >
      <div className="space-y-2" aria-hidden="true">
        <Skeleton className="h-7 w-48 sm:w-64" />
        <Skeleton className="h-4 w-full max-w-md" />
      </div>
      <div
        className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3"
        aria-hidden="true"
      >
        {Array.from({ length: 3 }).map((_, index) => (
          <div
            key={index}
            className="space-y-3 rounded-xl border border-border bg-card p-4"
          >
            <Skeleton className="h-4 w-1/3" />
            <Skeleton className="h-8 w-1/2" />
            <Skeleton className="h-3 w-4/5" />
          </div>
        ))}
      </div>
      <div
        className="rounded-xl border border-border bg-card p-4"
        aria-hidden="true"
      >
        <Skeleton className="h-4 w-40" />
        <Skeleton className="mt-4 h-48 w-full" />
      </div>
    </div>
  );
}
